/*
 * fn: getRecCardRefs
 *
 * Gets the card refs from a Rec as an array
 *
 */
import { type RecType } from '@/defs/rec'

export const getRecCardRefs = ({ cardId, name, partnerRef }: RecType) => [
  { cardId, name },
  ...(partnerRef ? [partnerRef] : []),
]
